import { isNumber } from '@witmetrics/utils/numbers';
import { formatNumber } from '@witmetrics/utils/strings';
import { includesKeyValue } from '@witmetrics/utils/arrays';
import { theme } from '@/utils/theme';
import type { CheckboxDropdownOption } from '@/components/inputs/CheckboxDropdown/types';

export const classes = {
  menu: 'rounded-xl mt-2 dark:bg-[#211d2f] dark:border dark:border-solid dark:border-white/[0.12]',
  menuItem:
    'transition-colors duration-100 text-grey-8 font-normal py-2 m-2 rounded-lg flex justify-between gap-2 dark:text-mauve-1',
  start: 'flex items-center gap-2',
  itemContent: 'flex flex-col items-start justify-start',
  contentDescription: 'text-sm text-grey-6 dark:text-mauve-3',
  inputIcon: 'text-xl text-grey-7 dark:text-mauve-2',
};

export const styles = {
  outlined: {
    '& .MuiInputBase-root': {
      // @ts-ignore
      borderRadius: theme.shape.rounded['3xl'],
      backgroundColor: 'white',
    },
    '.dark & .MuiInputBase-root': {
      backgroundColor: 'rgba(255,255,255,0.06)',
    },
  },
  filled: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiSelect-select, & .MuiSelect-select:focus': {
      paddingLeft: '1rem',
      color: theme.palette['grey-8'].main,
      fontWeight: 500,
      backgroundColor: theme.palette['grey-2'].main,
      // @ts-ignore
      borderRadius: theme.shape.rounded['3xl'],
      transition: 'filter 0.2s',
    },
    '& .MuiSelect-select:hover': {
      // @ts-ignore
      filter: 'brightness(0.98)',
    },
    '.dark & .MuiSelect-select, .dark & .MuiSelect-select:focus': {
      color: theme.palette['mauve-1'].main,
      backgroundColor: 'rgba(255,255,255,0.06)',
    },
  },
  box: { display: 'flex', flexWrap: 'wrap', gap: 0.5 },
  menuItem: {
    '&': {
      backgroundColor: theme.palette['white'].main,
    },
    '&:hover, &.Mui-selected, &.Mui-selected:hover, &.Mui-focusVisible, &.Mui-selected.Mui-focusVisible':
      {
        backgroundColor: theme.palette['grey-2'].main,
      },
    '.dark &': {
      backgroundColor: 'transparent',
      color: theme.palette['mauve-1'].main,
    },
    '.dark &:hover, .dark &.Mui-selected, .dark &.Mui-selected:hover, .dark &.Mui-focusVisible, .dark &.Mui-selected.Mui-focusVisible':
      {
        backgroundColor: 'rgba(255,255,255,0.06)',
      },
  },
};

export function buildOption<T extends string | number>(
  value: T,
  label?: string | number
): { value: T; label: string } {
  const labelValue = label || value;
  return {
    value,
    label: isNumber(labelValue) ? formatNumber(labelValue) : labelValue,
  };
}

export function isSelected<T extends string | number>(
  values: CheckboxDropdownOption<T>[],
  option: CheckboxDropdownOption<T>
) {
  return includesKeyValue(values, 'value', option.value);
}
